export async function DatePraca(token: string, countryId: number, pracaId: number) { 
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + `api/date?countryId=${countryId}&pracaId=${pracaId}`,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const response = await axios.request(options);
    return response;
}
